import { useState } from 'react';
import QuotationsList from './QuotationsList';
import QuotationEditor from './QuotationEditor';

export default function QuotationsView() {
  const [view, setView] = useState('list');
  const [editingId, setEditingId] = useState(null);

  const handleNew = () => {
    setEditingId(null);
    setView('editor');
  };

  const handleEdit = (id) => {
    setEditingId(id);
    setView('editor');
  };

  const handleBack = () => {
    setEditingId(null);
    setView('list');
  };

  if (view === 'editor') {
    return <QuotationEditor quotationId={editingId} onBack={handleBack} />;
  }

  return <QuotationsList onNew={handleNew} onEdit={handleEdit} />;
}
